import React from 'react';

interface OwnProps {
  /** Latest error message, if any. Errors take priority over status. */
  error: string | null;
  /** Most recent informational status (save success, etc.). */
  status: string | null;
}

/**
 * Renders the bottom-of-page status footer when an error or status
 * message is set. Returns `null` when both are absent so the parent
 * grid doesn't carry empty space.
 */
const EditorStatusBar = ({ error, status }: OwnProps) => {
  if (!error && !status) return null;
  const className = `status-footer ${error ? 'error' : 'success'}`;
  return (
    <footer role={error ? 'alert' : 'status'} className={className}>
      {error ? <span>{error}</span> : <span>{status}</span>}
    </footer>
  );
};

export default React.memo(EditorStatusBar);
